import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import useManageDrawer from '../../../../hooks/formHooks/useManageDrawer'

import { selectedPartnershipSelector } from '../../../../modules/selectors/partnerships'
import { clearGetSroiInputsPreset, getSroiInputsPreset } from '../../../../modules/actions/socialReturnOnInvestment'

export const useLoadSroiInputsPreset = ({ formName }) => {
  const selectedPartnership = useSelector(selectedPartnershipSelector)
  const selectedPartnershipId = selectedPartnership?.id
  const dispatch = useDispatch()

  const getSroiInputsPresetHandler = useCallback(() => {
    dispatch(
      getSroiInputsPreset({
        partnership: selectedPartnershipId
      })
    )
  }, [dispatch, selectedPartnershipId])

  const clearSroiInputsPresetHandler = useCallback(() => {
    dispatch(clearGetSroiInputsPreset())
  }, [dispatch])

  const { isFormOpen } = useManageDrawer({
    onAfterFormClose: clearSroiInputsPresetHandler,
    formName
  })

  useEffect(() => {
    if (isFormOpen) {
      getSroiInputsPresetHandler()
    }
  }, [getSroiInputsPresetHandler, isFormOpen])
}
